import '@content/foundations/src'
import asWebComponent from '../../../asWebComponent.ts'
import MgmReferral from '@components/member-get-member/mgm-referral/MgmReferral.tsx'

export default asWebComponent(MgmReferral, 'nb-mgm-referral', ['data'])
